export const environment = {
  production: false,
  api: 'https://api.campoprotegido.com.ar/api',
  auth0: {
    clientId: 'TG4gO2vsY8nZ9YVt9HjT6kkowy3aCZPg',
    domain: 'login.gruposancorseguros.com',
    scope: 'email'
  }
};